import { Layout } from "@certn/cascadia-react";
import { CascadiaIllustration } from "@certn/cascadia-tokens";
import { ReactNode } from "react";

import { AppFooterLinks } from "./app-footer/AppFooterLinks";
import { AppHeader } from "./app-header/AppHeader";
import { EmptyState } from "./EmptyState";

interface Props extends React.PropsWithChildren {
  illustration: CascadiaIllustration;
  title: string;
  message: string | ReactNode;
}

export function FullScreenErrorPage(props: Props) {
  const { title, message, illustration } = props;

  return (
    <Layout layout="narrow" header={<AppHeader />} footer={<AppFooterLinks />}>
      <EmptyState
        title={title}
        subtitle={message}
        illustration={illustration}
        actions={props.children}
      />
    </Layout>
  );
}
